import React, { useState, useEffect } from "react";
import { getSpaceId } from '../../Utils/authentication-access';
import SidebarItem from './SidebarItem';
import { spacesService } from '../../services/spaces.service';

const SideBarMenu = ({
  isDrawerOpen,
  count,
  spacesInfo,
  childCountChange,
  boardInfo,
  sortHandler,
  sortType,
}) => {
  const [activeBoard, setActiveBoard] = useState();
  const [selectedSpaces, setSelectedSpaces] = useState([]);

  useEffect(() => {
    callGetSpaces();
  }, [isDrawerOpen]);

  useEffect(() => {
    callGetSpaces();
  }, [count]);

  const callGetSpaces = async () => {
    await spacesService.getSpaces();
  };

  useEffect(() => {
    let spaceID = getSpaceId();
    setSelectedSpaces([spaceID]);
  }, []);

  return (
    <div>

      {spacesInfo !== 0 ?
        <>
          {spacesInfo &&
            spacesInfo.map((item, index) => (
              <SidebarItem
                key={index}
                item={item}
                setSelectedSpaces={setSelectedSpaces}
                selectedSpaces={selectedSpaces}
                childCountChange={childCountChange}
                spacesCount={spacesInfo.length}
                boardInfo={boardInfo}
                isDrawerOpen={isDrawerOpen}
                setActiveBoard={setActiveBoard}
                activeBoard={activeBoard}
                sortHandler={sortHandler}
                sortType={sortType}
              />
            ))}
        </>
        :
        <div style={{
          margin: '20%',
          textAlign: 'center',
        }}>Loading...</div>
      }
    </div>
  );
};

export default SideBarMenu;
